// fnv-1a 32-bit: correlates a token across logs without exposing it
export function fingerprint(token: string | undefined): string {
	if (!token) return "none";
	let hash = 0x811c9dc5;
	for (let i = 0; i < token.length; i++) {
		hash = Math.imul(hash ^ (token.codePointAt(i) ?? 0), 0x01000193);
	}
	return (hash >>> 0).toString(16).padStart(8, "0");
}
